import { DASHBOARDS } from 'constants/dashboards';
import { useCallback, useMemo, useState } from 'react';
import datetimeService from 'services/datetime.service';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

export const useSelectTime = () => {
    const [startTime, setStartTime] = useState<any>(datetimeService.startDateUnixOfCurrentMonth());
    const [endTime, setEndTime] = useState<any>(datetimeService.endDateUnixOfCurrentMonth());
    const [timeFrame, setTimeFrame] = useState<string>('');

    const [startDate, setStartDate] = useState<any>(dayjs().utc().startOf('month').format('MM/DD/YYYY'));
    const [endDate, setEndDate] = useState<any>(dayjs().utc().endOf('month').format('DD/MM/YYYY'));

    const timeFrameOptions = useMemo(() => {
        return [
            { label: 'Current Month', value: DASHBOARDS.CURRENT_MONTH },
            { label: 'Last Month', value: DASHBOARDS.LAST_MONTH },
            { label: 'All Time', value: DASHBOARDS.ALL_TIME },
        ];
    }, []);

    const timeFramePayoutOptions = useMemo(() => {
        return [
            { label: 'Last Month', value: DASHBOARDS.LAST_MONTH },
            { label: 'Current Month', value: DASHBOARDS.CURRENT_MONTH },
        ];
    }, []);

    const onChangeFilter = useCallback((key, value) => {
        if (key === 'timeFrame') {
            let startTime = 0;
            let endTime = 0;

            if (value === DASHBOARDS.CURRENT_MONTH) {
                startTime = datetimeService.startDateUnixOfCurrentMonth();
                endTime = datetimeService.endDateUnixOfCurrentMonth();
            }

            if (value === DASHBOARDS.LAST_MONTH) {
                startTime = datetimeService.startDateUnixBeforeMonth(1);
                endTime = datetimeService.endDateUnixOfBeforeMonth(1);
            }
            setStartTime(() => ({
                startTime,
            }));
            setEndTime(() => ({
                endTime,
            }));
            setTimeFrame(value);
        } else {
            setStartTime(() => ({
                [key]: value,
            }));
            setEndTime(() => ({
                [key]: value,
            }));
        }
    }, []);

    const onChangTime = useCallback((dateString) => {
        let startTime = 0;
        let endTime = 0;
        if (dateString) {
            const [year, month] = dateString && dateString.split('-');
            startTime = datetimeService.startDateUnixOfMonth(year, month);
            endTime = datetimeService.endDateUnixOfMonth(year, month);
            setStartDate(dayjs(`${year}-${month}-01`).startOf('month').format('MM/DD/YYYY'));
            setEndDate(dayjs(`${year}-${month}-01`).endOf('month').format('MM/DD/YYYY'));
        } else {
            startTime = datetimeService.startDateUnixOfCurrentMonth();
            endTime = datetimeService.endDateUnixOfCurrentMonth();
            setStartDate(dayjs().utc().startOf('month').format('MM/DD/YYYY'));
            setEndDate(dayjs().utc().endOf('month').format('DD/MM/YYYY'));
        }
        setStartTime(() => startTime);
        setEndTime(() => endTime);
    }, []);

    return { onChangTime, onChangeFilter, timeFrameOptions, endTime, startTime, timeFramePayoutOptions, timeFrame, startDate, endDate };
};
